module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n          Подготовьте файл (xslx, csv), содержащий колонки: "), _c('b', [_vm._v(" дата")]), _vm._v(", "), _c('b', [_vm._v("название")]), _vm._v(" операции и "), _c('b', [_vm._v(" увеличение")]), _vm._v(", "), _c('b', [_vm._v("уменьшение долга")]), _vm._v(".\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Выберите файл\n            ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Задайте соответствие полей документа и колонок в загружаемом файле\n      ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Поле")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Название колонки")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Пример значения")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(field.label) + _vm._s(field.key ? ' (идентификатор)' : ''))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "items": _vm.getNewFields(),
        "item-value": "value",
        "item-text": "text"
      },
      model: {
        value: (field.number),
        callback: function($$v) {
          _vm.$set(field, "number", $$v)
        },
        expression: "field.number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(field)))])])], 1)]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Данные игнорируются если не удовлетворяют формату.\n        "), (_vm.exsistDate) ? _c('v-flex', {
    attrs: {
      "pl-3": "",
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Формат дат",
      "hint": "Выберите формат для полей даты",
      "persistent-hint": "",
      "items": [{
          value: 'DD.MM.YYYY',
          text: 'дд.мм.гггг'
        },
        {
          value: 'DD.MM.YY',
          text: 'дд.мм.гг'
        },
        {
          value: 'DD/MM/YYYY',
          text: 'дд/мм/гггг'
        },
        {
          value: 'DD/MM/YY',
          text: 'дд/мм/гг'
        },
        {
          value: 'YYYY-MM-DD',
          text: 'гггг-мм-дд'
        }
      ]
    },
    model: {
      value: (_vm.dateFormat),
      callback: function($$v) {
        _vm.dateFormat = $$v
      },
      expression: "dateFormat"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8ab90c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/fields/CalcCSVLoader.vue
// module id = 941
// module chunks = 1